export const MESSAGES = {
  favorite: {
    false: {
      success: 'Report marked as favorite successfully.',
      error: 'Failed to mark report as favorite. Please try again.'
    },
    true: {
      success: 'Report removed from favorites successfully.',
      error: 'Failed to remove report from favorites. Please try again.'
    }
  },
  delete: {
    success: 'Report deleted successfully.',
    error: 'Failed to delete report. Please try again.'
  }
};
